import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {
  // Configuration of locale for p-calendar.
  config;

  // Object with the locale key mapping (short or long).
  localeKeyConstant;

  // Current language of the app (short or long).
  activeLangKey: string;

  constructor() {
  }

  setDatepickerConfig(config, localeKeyConstant): void {
    this.config = config;
    this.localeKeyConstant = localeKeyConstant;
  }

  setDatepickerLanguage(langKey: string): void {
    this.activeLangKey = langKey;
  }

  getConfig(): any {
    if (!this.config[this.activeLangKey]) {
      return this.config[this.localeKeyConstant.DEFAULT];
    }

    return this.config[this.activeLangKey];
  }

}
